(function () {
  if (window.__collapsibleImageCardsScriptBound) return;
  window.__collapsibleImageCardsScriptBound = true;

  class CollapsibleImageCardsSection {
    constructor(section) {
      this.section = section;
      this.slider = section.querySelector('.swiper--collapsible-image-cards');
      this.toggles = Array.from(section.querySelectorAll('.collapsible-image-cards__toggle'));
      this.resizeObserver = null;
      this.boundHandleToggle = this.handleToggle.bind(this);
      this.boundHandleResize = this.handleResize.bind(this);
      this.init();
    }

    init() {
      this.bindToggles();

      if (this.slider) {
        this.resizeObserver = new ResizeObserver(this.boundHandleResize);
        this.resizeObserver.observe(this.section);
        this.handleResize();
      }
    }

    bindToggles() {
      this.toggles.forEach((toggle) => {
        toggle.addEventListener('click', this.boundHandleToggle);
      });
    }

    handleToggle(event) {
      const toggle = event.currentTarget;
      const item = toggle.closest('.collapsible-image-cards__item');
      const content = item.querySelector('.collapsible-image-cards__content');
      const isOpen = item.classList.contains('is-open');

      if (!content) return;

      if (isOpen) {
        this.closeItem(item, toggle, content);
      } else {
        this.openItem(item, toggle, content);
      }

      if (this.slider && this.slider.swiper) {
        window.requestAnimationFrame(() => {
          this.slider.swiper.updateAutoHeight(300);
          this.slider.swiper.update();
          this.updateScrollbar();
        });
      }
    }

    openItem(item, toggle, content) {
      item.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');

      if (window.jQuery) {
        window.jQuery(content).stop(true, true).slideDown(300);
      } else {
        content.style.display = 'block';
      }
    }

    closeItem(item, toggle, content) {
      item.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');

      if (window.jQuery) {
        window.jQuery(content).stop(true, true).slideUp(300);
      } else {
        content.style.display = 'none';
      }
    }

    handleResize(entries) {
      const entry = entries && entries[0] ? entries[0] : { contentRect: this.section.getBoundingClientRect() };

      if (entry.contentRect.width < 990) {
        this.initSlider();
      } else {
        this.destroySlider();
      }
    }

    initSlider() {
      if (!this.slider || this.slider.swiper) return;

      const list = this.slider.querySelector('.collapsible-image-cards__list');
      const items = this.slider.querySelectorAll('.collapsible-image-cards__item');
      if (!items.length || items.length <= 1) return;
      const thumb = this.section.querySelector('.collapsible-image-cards__scrollbar-thumb');
      const isSubtlePeek = this.slider.dataset.mobilePeek === 'subtle';

      this.slider.classList.add('swiper');
      if (list) list.classList.add('swiper-wrapper');
      items.forEach((item) => item.classList.add('swiper-slide'));

      this.sliderInstance = new Swiper(this.slider, {
        speed: 800,
        watchOverflow: true,
        autoHeight: true,
        slidesPerView: isSubtlePeek ? 1.06 : 1.14,
        spaceBetween: 12,
        breakpoints: {
          576: {
            slidesPerView: isSubtlePeek ? 1.18 : 1.26,
            spaceBetween: 12
          },
          750: {
            slidesPerView: 2.05,
            spaceBetween: 16
          }
        },
        on: {
          init: () => {
            this.updateScrollbar();
          },
          slideChange: () => {
            this.updateScrollbar();
          },
          resize: () => {
            this.updateScrollbar();
          },
          update: () => {
            this.updateScrollbar();
          }
        }
      });

      if (thumb) {
        this.updateScrollbar();
      }
    }

    updateScrollbar() {
      if (!this.slider || !this.slider.swiper) return;

      const thumb = this.section.querySelector('.collapsible-image-cards__scrollbar-thumb');
      const swiper = this.slider.swiper;

      if (!thumb) return;

      const totalSteps = swiper.snapGrid && swiper.snapGrid.length ? swiper.snapGrid.length : 1;
      const thumbWidth = 100 / totalSteps;
      const maxTranslate = 100 - thumbWidth;
      const progress = totalSteps > 1 ? swiper.activeIndex / (totalSteps - 1) : 0;

      thumb.style.width = `${thumbWidth}%`;
      thumb.style.transform = `translateX(${maxTranslate * progress}%)`;
    }

    destroySlider() {
      if (!this.slider) return;

      const list = this.slider.querySelector('.collapsible-image-cards__list');
      const items = this.slider.querySelectorAll('.collapsible-image-cards__item');
      const thumb = this.section.querySelector('.collapsible-image-cards__scrollbar-thumb');

      if (this.slider.swiper) {
        this.slider.swiper.destroy(true, true);
      }

      this.slider.classList.remove('swiper');
      if (list) list.classList.remove('swiper-wrapper');
      items.forEach((item) => {
        item.classList.remove('swiper-slide');
        item.removeAttribute('style');
      });

      if (thumb) {
        thumb.style.width = '';
        thumb.style.transform = '';
      }
    }

    destroy() {
      this.toggles.forEach((toggle) => {
        toggle.removeEventListener('click', this.boundHandleToggle);
      });

      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }

      this.destroySlider();
      this.section.collapsibleImageCardsInstance = null;
    }
  }

  const initCollapsibleImageCards = (root = document) => {
    const sections = [];

    if (root instanceof Element && root.matches('.section-collapsible-image-cards')) {
      sections.push(root);
    }

    sections.push(...root.querySelectorAll('.section-collapsible-image-cards'));

    sections.forEach((section) => {
      if (section.collapsibleImageCardsInstance) return;

      section.collapsibleImageCardsInstance = new CollapsibleImageCardsSection(section);
    });
  };

  initCollapsibleImageCards();

  document.addEventListener('shopify:section:load', function (event) {
    initCollapsibleImageCards(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    const section = event.target;

    if (section && section.collapsibleImageCardsInstance) {
      section.collapsibleImageCardsInstance.destroy();
    }
  });
})();
